'use strict';

import {EwSiteApp} from "../app/ewsiteapp.js";

EwSiteApp.factory('notify', ["$mdToast", function($mdToast){
	const successMessageDelay = 10000;
	const toastPosition = 'top right';
	const toastAction = 'x';
	const toastActionKey = 'q';
	return function(message){
		let msg = new String();
		if(angular.isArray(message)){
			msg = message.join('; ');
		}
		else{
			msg = message;
		}
		if(arguments[1]){
			$mdToast.show($mdToast
							.simple()
							.textContent(msg)
							.position(toastPosition)
							.hideDelay(0)
							.action(toastAction)
							.actionKey(toastActionKey)
							.theme('error-toast')
			);
		}
		else{
			$mdToast.show($mdToast
							.simple()
							.textContent(msg)
							.position(toastPosition)
							.hideDelay(successMessageDelay)
							.action(toastAction)
							.actionKey(toastActionKey)
							.theme('success-toast')
			);
		}
	};
}]);